import React, { useState, useEffect } from 'react';

const RevenueCalculator = () => {
  const [screenSize, setScreenSize] = useState('55');
  const [locationType, setLocationType] = useState('coffee-shop');
  const [hours, setHours] = useState(12);
  const [monthlyEarnings, setMonthlyEarnings] = useState(680);

  const calculateEarnings = () => {
    const baseRates = {
      '32': 50,
      '55': 120,
      '75': 210
    };

    const locationMultipliers = {
      'coffee-shop': 1.0,
      'restaurant': 1.2,
      'retail-store': 1.4,
      'office-lobby': 0.8
    };

    const baseRate = baseRates[screenSize] || 2.5;
    const multiplier = locationMultipliers[locationType] || 1.0;
    const earnings = Math.round(hours * baseRate * multiplier * 30);
    setMonthlyEarnings(earnings);
  };

  useEffect(() => {
    calculateEarnings();
  }, [screenSize, locationType, hours]);

  return (
    <div className="bg-white rounded-xl p-6 mb-6 shadow-sm">
      <h4 className="text-lg font-semibold text-text-primary mb-4">Revenue Calculator</h4>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">Screen Size</label>
          <select 
            value={screenSize}
            onChange={(e) => setScreenSize(e.target.value)}
            className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
          >
            <option value="32">32" - Small Display</option>
            <option value="55">55" - Medium Display</option>
            <option value="75">75" - Large Display</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">Location Type</label>
          <select 
            value={locationType}
            onChange={(e) => setLocationType(e.target.value)}
            className="w-full p-3 border border-border rounded-lg focus:border-primary focus:outline-none"
          >
            <option value="coffee-shop">Coffee Shop</option>
            <option value="restaurant">Restaurant</option>
            <option value="retail-store">Retail Store</option>
            <option value="office-lobby">Office Lobby</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">Daily Operating Hours</label>
          <input 
            type="range" 
            min="8" 
            max="24" 
            value={hours}
            onChange={(e) => setHours(parseInt(e.target.value))}
            className="w-full" 
          />
          <div className="flex justify-between text-sm text-text-secondary">
            <span>8h</span>
            <span>{hours}h</span>
            <span>24h</span>
          </div>
        </div>
      </div>
      
      <div className="mt-6 p-4 bg-primary/10 rounded-lg">
        <div className="text-center">
          <div className="text-3xl font-bold text-primary">₹{monthlyEarnings.toLocaleString()}</div>
          <div className="text-sm text-text-secondary">Estimated Monthly Earnings</div>
        </div>
      </div>
    </div>
  );
};

export default RevenueCalculator;